import { Area } from "./AreaHierarchy"

export class Outdoor extends Area {
    static entity = 'outdoors'

    // Reference to base entity name.
    static baseEntity = 'areas'

    // Call `super.fields()`` to merge fields.
    static fields() {
        return {
            ...super.fields()
        }
    }
}

// We also export a default.
export default Outdoor;